import { TranslateService } from '@ngx-translate/core';

interface ITranslateMessageError {
  getTranslateMessage(translate?: TranslateService): string;
}

export class FormulaSyntaxError
  extends Error
  implements ITranslateMessageError
{
  constructor(
    public context?: {
      template?: string;
      variables?: Record<string, number | string | null>;
    },
  ) {
    super('FormulaSyntaxError');
    this.name = 'FormulaSyntaxError';
  }

  getTranslateMessage(): string {
    return 'FORMULA.FormulaSyntaxError';
  }
}

export class FormulaFieldNameNotFoundError
  extends Error
  implements ITranslateMessageError
{
  constructor(public fieldName: string) {
    super('FormulaFieldNameNotFoundError');
    this.name = 'FormulaFieldNameNotFoundError';
  }

  getTranslateMessage(): string {
    return `FORMULA.FormulaFieldNameNotFoundError,$fieldName=${this.fieldName}`;
  }
}

export class FormulaCircularReferenceError
  extends Error
  implements ITranslateMessageError
{
  constructor() {
    super('FormulaCircularReferenceError');
    this.name = 'FormulaCircularReferenceError';
  }

  getTranslateMessage(): string {
    return 'FORMULA.FormulaCircularReferenceError';
  }
}
